// The head every section opens with: optional eyebrow, an H2 whose words blur
// in one by one, a lead that follows at .25s, and an optional aside at the far
// side (a .ld-ghost link) at .35s.
//
//   <SectionHead id="ld-faq-title" title={...} lead={...} aside={<a className="ld-ghost" ...>} />
//
// `flat` drops the bottom margin, for a head that shares a grid with something.
// Point the section's aria-labelledby at `id`.

import Words from "../Home/motion/Words";

export default function SectionHead({ id, eyebrow, title, lead, aside, flat = false, className = "" }) {
    return (
        <div className={`ld-head ${flat ? "ld-head--flat" : ""} ${className}`.trim()}>
            <div className="ld-head__text">
                {eyebrow ? <span className="ld-eyebrow" data-ld="rise">{eyebrow}</span> : null}
                {title ? (
                    <h2 className="ld-h2" id={id} data-ld="words">
                        <Words text={title} wordClass="ld-word" />
                    </h2>
                ) : null}
                {lead ? (
                    <p className="ld-lead ld-head__lead" data-ld="rise" style={{ "--ld-d": ".25s" }}>{lead}</p>
                ) : null}
            </div>
            {aside ? (
                <div className="ld-head__aside" data-ld="rise" style={{ "--ld-d": ".35s" }}>{aside}</div>
            ) : null}
        </div>
    );
}
